import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
} from "@mui/material";
import { get } from "src/utils/networkUtils";
import UsersCountSummary from "../users/UsersCountSummary";
import UsersSignupChart from "../users/UsersSignupChart";
import GameProviderUsersTable from "./GameProviderUsersTable";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

export default function GameProviderStatsDialog(props) {
  const [gameProviderStats, setGameProviderStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (props?.gameProviderId) {
      get(`/admin/game-providers/${props.gameProviderId}/stats`).then(
        (response) => {
          setGameProviderStats(response.stats);
          setLoading(false);
        }
      );
    }
  }, [props?.gameProviderId]);

  const onCancel = () => {
    props.onClose();
  };
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogContent>
        {loading || gameProviderStats === null ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={6} md={3} lg={3} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Handle"
                total={gameProviderStats.totalEntryFeeCoins ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={6} md={3} lg={3} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Payouts"
                total={gameProviderStats.totalPrizeCoins ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={6} md={2} lg={2} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Profit"
                total={
                  gameProviderStats.totalEntryFeeCoins -
                  gameProviderStats.totalPrizeCoins
                }
                color="info"
              />
            </Grid>
            <Grid item xs={6} md={2} lg={2} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Margin (%)"
                total={Math.round(
                  ((gameProviderStats.totalEntryFeeCoins -
                    gameProviderStats.totalPrizeCoins) /
                    gameProviderStats.totalEntryFeeCoins) *
                    100
                )}
                color="info"
              />
            </Grid>
            <Grid item xs={6} md={2} lg={2} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Win(%)"
                total={Math.round(
                  (gameProviderStats.winsRatio * 100).toFixed(2) ?? 0
                )}
                color="info"
              />
            </Grid>
            <Grid item xs={12} md={9} lg={9} sx={{ m: 0, p: 1 }}>
              <UsersSignupChart
                title="Coins Spent"
                subheader=""
                height={200}
                chartLabels={gameProviderStats.entryAmountsPerDay.map(
                  (date) => date.date
                )}
                chartData={[
                  {
                    name: "Coins",
                    type: "column",
                    fill: "solid",
                    data: gameProviderStats.entryAmountsPerDay.map(
                      (date) => date.totalSpent
                    ),
                  },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ m: 0, p: 1 }}>
              <UsersCountSummary
                title="Total Players"
                total={gameProviderStats.totalUsers ?? 0}
                color="info"
              />
              <UsersCountSummary
                sx={{ mt: 2 }}
                title="Average Entry"
                total={gameProviderStats.avgEntry ?? 0}
                color="info"
              />
              <UsersCountSummary
                sx={{ mt: 2 }}
                title="Average Prize"
                total={gameProviderStats.avgPrize ?? 0}
                color="info"
              />
            </Grid>

            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChangeTabs}
                  aria-label="basic tabs example"
                >
                  <Tab label="Top 20 Whales" {...a11yProps(0)} />
                  <Tab label="Top 20 Sharps" {...a11yProps(1)} />
                  <Tab label="Top 20 Users" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <GameProviderUsersTable
                  rows={gameProviderStats.topLosingUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <GameProviderUsersTable
                  rows={gameProviderStats.topWinningUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <GameProviderUsersTable
                  rows={gameProviderStats.topSpendingUsers}
                />
              </TabPanel>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
